<template>
  <div class="branch_container">
    <h2>{{ branchInfo.title }}</h2>
    <div class="wrapper">
      <div
        v-if="branchInfo.address"
      >
        <i class="el-icon-map-location"></i>
        地址：{{ branchInfo.address }}
      </div>
      <div
        v-if="branchInfo.tel"
      >
        <i class="el-icon-phone-outline"></i>
        电话：{{ branchInfo.tel }}
      </div>
      <div
        v-if="branchInfo.fax"
      >
        <i class="el-icon-printer"></i>
        传真：{{ branchInfo.fax }}
      </div>
      <div
        v-if="branchInfo.zipcode"
      >
        <i class="el-icon-postcard"></i>
        邮编：{{ branchInfo.zipcode }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Branch',
  data () {
    return {
      id: '',
      list: [{
        id: 'shanghai',
        title: '上海',
        address: '上海市虹口区东大名路908号金岸大厦十三层E座',
        tel: '021-65957777',
        fax: '021-65959999',
        zipcode: '200082'
      }, {
        id: 'tianjin',
        title: '天津',
        address: '天津市河西区南京路20号金皇大厦4302室',
        tel: '022-58196668',
        fax: '022-581966618',
        zipcode: '300012'
      }, {
        id: 'dalian',
        title: '大连',
        address: '大连市中山区长江路38号金地中心B3704室',
        tel: '0411-82518068',
        fax: '0411-82518788',
        zipcode: '116001'
      }, {
        id: 'qingdao',
        title: '青岛',
        address: '青岛市城阳区流亭机场凤岗路8号普洛斯海关快件监管中心208室',
        tel: '85798555',
        fax: '0532-89087709',
        zipcode: '266000'
      }, {
        id: 'yantai',
        title: '烟台',
        address: '烟台市芝罘区南大街213号1206室',
        tel: '0535-2150925',
        fax: '0535-2150929',
        zipcode: '264000'
      }, {
        id: 'weihai',
        title: '威海',
        address: '威海市蓝星万象城23号B2410室',
        tel: '0535-2150925',
        fax: '0535-2150929 ',
        zipcode: '264200'
      }, {
        id: 'nanjing',
        title: '南京',
        address: '南京市秦淮区中山东路300号长发中心B栋2002室',
        tel: '025-84563801/02',
        zipcode: '210002'
      }, {
        id: 'ningbo',
        title: '宁波',
        address: '宁波市海曙区华楼巷21号天一豪景B座1607室',
        tel: '0574-27895777',
        fax: '0574-27820858',
        zipcode: '315040'
      }, {
        id: 'guangzhou',
        title: '广州',
        address: '广州市白云区棠景街6号8楼'
      }, {
        id: 'shenzhen',
        title: '深圳',
        address: '深圳市南山区南海大道南山大厦北座509室'
      }, {
        id: 'changsha',
        title: '长沙',
        address: '长沙市开福区青竹湖路29号长沙金霞海关保税物流投资建设有限公司商务写字楼1108-1室',
        zipcode: '200082'
      }, {
        id: 'wuhan',
        title: '武汉',
        address: '武汉市江汉区后襄河北路海马中心1栋1413室',
        tel: '027-83918166/83918266',
        zipcode: '430000'
      }, {
        id: 'shanghai',
        title: '上海',
        address: '上海市虹口区东大名路908号金岸大厦十三层E座',
        tel: '021-65957777',
        fax: '021-65959999',
        zipcode: '200082'
      }, {
        id: 'meiguo',
        title: '美国',
        address: '415 MILLCREEK LN NAPERVILLE,IL.60540-8228',
        tel: '(630) 717-5995'
      }, {
        id: 'riben',
        title: '日本',
        address: '东京都足立区足立四丁目13番12号'
      }, {
        id: 'aodaliya',
        title: '澳大利亚',
        address: 'CHI & ASSOCIATES PO BOX 628 BROWNS PLAINS QLD 4118'
      }, {
        id: 'xianggang',
        title: '香港',
        address: 'RM 1501(698),15/F SPA CTR 53-55 LOCKHART RD WANCHAI HONGKONG'
      }]
    }
  },
  created () {
    this.id = this.$route.params.id
  },
  mounted () {
    document.title = this.branchInfo.title
  },
  methods: {
    redirectTo () {
      this.$router.push('/404')
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.id = to.params.id
    document.title = this.branchInfo.title
    next()
  },
  computed: {
    branchInfo: function () {
      let list = this.list
      let id = this.id
      let obj = {}
      for (let i of list) {
        if (i.id === id) {
          obj = i
          break
        }
      }
      if (JSON.stringify(obj) === '{}') {
        this.redirectTo()
      }
      return obj
    }
  }
}
</script>

<style lang="scss" scoped>
.branch_container {
  max-width: 1200px;
  margin: 50px auto;
  h2 {
    text-align: center;
    font-size: 32px;
    margin: 10px;
  }
  .wrapper {
    font-size: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    line-height: 30px;
    color: #333;
  }
}
</style>
